
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    order: Object,
  },
});
